/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Footer component
 * @author Dustin Gage
 */

import React, { memo, ReactElement } from "react";
import { useSettings } from "../../api/use-settings";
import { getString } from "../../api/get-string";
import { StringResource } from "../StringResource";

interface IProps {}

export const Footer = memo(function Footer(props: IProps): ReactElement {
	const {} = props;
	const {
		FooterPrivacyPolicyAriaLabel,
		FooterCopyright,
		FooterAllRightsReserved,
		FooterPrivacyPolicy,
	} = StringResources.covidtriage;

	const footerPrivacyPolicyAriaLabel = getString(FooterPrivacyPolicyAriaLabel);
	const copyright = getString(FooterCopyright);
	const { privacyPolicyUrl } = useSettings();

	return (
		<>
			<footer className="footer">
				<span className="footer-copyright-text">
					<StringResource raw={copyright} />
				</span>
				<span className="footer-rights-reserved-text">
					<StringResource token={FooterAllRightsReserved} />
				</span>
				{!!privacyPolicyUrl ? (
					<span className="footer-privacy-policy">
						<a href={privacyPolicyUrl} aria-label={footerPrivacyPolicyAriaLabel}>
							<StringResource token={FooterPrivacyPolicy} />
						</a>
					</span>
				) : (
					void 0
				)}
			</footer>
		</>
	);
});
